import React, { Component, Fragment} from 'react'
import InputSelect from "./FormInputSelect"
import InputText from "./FormInputText"

export default class FormInput extends Component {
   

    render() {

        const component = this.props.as

        return (
        <Fragment>
            {component === 'TextField'      && <InputText props={this.props}/>}
            {component === 'Select'         && <InputSelect props={this.props}/>}
           {/*  {component === 'Autocomplete'   && <ImputAutocomplete />} */}
        </Fragment>    
        )
    }
}